var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    staticClass: "mb-[2.5rem]",
    attrs: {
      "label": _vm.$t('Member No.'),
      "prop": "memberno"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.form.memberno,
      callback: function ($$v) {
        _vm.$set(_vm.form, "memberno", $$v);
      },
      expression: "form.memberno"
    }
  })], 1), _c('el-form-item', [_c('el-button', {
    staticClass: "green-button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.submitForm('form');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Verify Account')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };